import { formatDate } from 'ClientService';

export const LagRatingResponseDate = ({ value, record }) => record.lagRatingResponseDate ? formatDate(record.lagRatingResponseDate) : '';
